var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModeratorLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.425,
    height: 11.999,
    viewBox: "0 0 10.425 11.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M5.208,7.09A2.148,2.148,0,0,0,7.415,5,2.21,2.21,0,0,0,5.208,2.828,2.148,2.148,0,0,0,3,4.922,2.264,2.264,0,0,0,5.208,7.09ZM1.5,1.408a5.437,5.437,0,0,1,7.41,0,4.785,4.785,0,0,1,0,7.028L5.208,11.949,1.5,8.435A4.916,4.916,0,0,1,1.5,1.408Z",
    transform: "translate(-0.025 0.05)",
    fill: "#373334",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeratorLocationIcon);
export default __webpack_public_path__ + "static/media/moderatorLocationIcon.7cd5ce4545dd50787cd71a3c93bad0c6.svg";
export { ForwardRef as ReactComponent };